
import { defineComponent } from 'vue';
import { transformSpace } from '@/lib/transformUrl';
import { Button, Tooltip } from 'ant-design-vue';
import { EllipsisOutlined } from '@ant-design/icons-vue';
import { CardData } from './lib/interface';

export default defineComponent({
  name: 'CaseCard',
  components: {
    aTooltip: Tooltip,
    aButton: Button,
    EllipsisOutlined,
  },
  props: {
    cover: {
      type: Boolean,
      default: false,
    },
    cardData: {
      type: CardData,
      default: () => new CardData({}),
    },
  },
  emits: ['distribute', 'option'],
  setup(_, { emit }) {
    const handleDistributeClick = () => {
      emit('distribute');
    };
    const handleOptionClick = () => {
      emit('option');
    };
    return {
      transformSpace,
      handleDistributeClick,
      handleOptionClick,
    };
  },
});
